module.exports = __webpack_public_path__ + "static/files/acv_playingSoccer.ca14bd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/acv_playingSoccer.png
// module id = Hjc9
// module chunks = 0